import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinusFillCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4Zm-8.516 18.58a.745.745 0 0 1-.774-.773v-3.613c0-.387.322-.775.774-.775h17.032c.387 0 .774.387.774.774v3.613a.784.784 0 0 1-.774.775H11.484Z" })
});
export default SvgMinusFillCircle;
